var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("search-bar", { on: { searchPendingApproval: _vm.getSearchResult } }),
      _c(
        "div",
        { staticClass: "pending-list-container" },
        [
          _c("b-table", {
            attrs: {
              fields: _vm.pendingRegUserFields,
              items: _vm.$store.state.pendingAction.userPendingRegList,
              "per-page": _vm.perPage,
              "current-page": _vm.currentPage,
              "sort-direction": "asc",
              bordered: "",
              striped: "",
              hover: "",
              footClone: ""
            },
            scopedSlots: _vm._u([
              {
                key: "actions",
                fn: function(row) {
                  return [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "outline-info", size: "sm" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            _vm.popUpFileModal(
                              row.item,
                              row.index,
                              $event.target
                            )
                          }
                        }
                      },
                      [_vm._v("\n          Files\n        ")]
                    ),
                    _vm._v(" |\n        "),
                    _c(
                      "b-button",
                      {
                        attrs: {
                          variant: "outline-info",
                          to: { path: "/dashboard/management/" + row.item.id },
                          size: "sm"
                        }
                      },
                      [_vm._v("\n          Edit\n        ")]
                    ),
                    _vm._v(" |\n        "),
                    _c(
                      "b-button",
                      {
                        attrs: { size: "sm", variant: "outline-success" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            _vm.approveUser(row.item, row.index, $event.target)
                          }
                        }
                      },
                      [_vm._v("\n          Approve\n        ")]
                    ),
                    _vm._v(" |\n        "),
                    _c(
                      "b-button",
                      {
                        attrs: { size: "sm", variant: "danger" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            _vm.rejectUser(row.item, row.index, $event.target)
                          }
                        }
                      },
                      [_vm._v("\n          Reject")]
                    )
                  ]
                }
              }
            ])
          }),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "my-1", attrs: { md: "6" } },
                [
                  _c("b-pagination", {
                    staticClass: "my-0",
                    attrs: {
                      "total-rows": _vm.totalRows,
                      "per-page": _vm.perPage
                    },
                    model: {
                      value: _vm.currentPage,
                      callback: function($$v) {
                        _vm.currentPage = $$v
                      },
                      expression: "currentPage"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "fileListModal",
            title: _vm.fileListModal.title,
            "ok-only": ""
          }
        },
        [
          !!_vm.fileListModal.content.fileList.length
            ? _c(
                "div",
                _vm._l(_vm.fileListModal.content.fileList, function(
                  item,
                  index
                ) {
                  return _c("p", [
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "/userMsManager/download/" +
                            _vm.fileListModal.content.nricFin +
                            "/" +
                            item,
                          download: item
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(index) +
                            ": " +
                            _vm._s(item) +
                            "\n        "
                        )
                      ]
                    )
                  ])
                })
              )
            : _c("div", [_c("p", [_vm._v("No files uploaded")])])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52f524a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52f524a6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/dashboard/pendingAction/PendingList.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-52f524a6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/dashboard/pendingAction/PendingList.vue
// module chunks = 1 4 5